export type NewCoachesOptionId =
  | 'all'
  | 'any'
  | '30'
  | '60'
  | '90'
  | 'combined'
  | 'current'
  | 'previous'
  | 'previous2';

export interface BuildNewCoachesOptionsParams {
  ffTeamsOrgSR: boolean;
  reportHeading: string;
  onSelect: (id: string) => void;
}

export const NEW_COACHES_OPTIONS = [
  {text: 'All Coaches (default)', id: 'all', defaultVal: true},
  {text: 'Last 30 days', id: '30', defaultVal: false},
  {text: 'Last 60 days', id: '60', defaultVal: false},
  {text: 'Last 90 days', id: '90', defaultVal: false},
];

export const NEW_COACHES_OPTIONS_TEAMS_ORG_SR = [
  {text: 'Any time', id: 'any', defaultVal: true},
  {text: 'Current month', id: 'current', defaultVal: false},
  {text: 'Last month', id: 'previous', defaultVal: false},
  {text: '2 Months ago', id: 'previous2', defaultVal: false},
  {text: 'Combined (Last 3 months)', id: 'combined', defaultVal: false},
];
